export enum ReAccountingStatus {
  ACCOUNTED = 'ACCOUNTED',
  PARTIAL_ACCOUNTED = 'PARTIAL_ACCOUNTED',
  NOT_ACCOUNTED = 'NOT_ACCOUNTED',
}
